// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"eb92349c","284":"486eda37","626":"282359d9","651":"161385f6"}[chunkId] + ".chunk.js";
};